import { render } from "./Consumer.vue?vue&type=template&id=430cd803&scoped=true"
import script from "./Consumer.vue?vue&type=script&lang=js"
export * from "./Consumer.vue?vue&type=script&lang=js"

import "./Consumer.vue?vue&type=style&index=0&id=430cd803&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430cd803"]])

export default __exports__